import React, { useEffect, useRef, useState } from "react";
import { Button, Container, Modal, Spinner, Table } from "react-bootstrap";
import {
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Typography,
  createFilterOptions,
} from "@mui/material";
import { LocalizationProvider, TimePicker } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import notify from "../../../Notifcation";
import { useDispatch, useSelector } from "react-redux";
import {
  CreateRequestEmpAction,
  GetAllRequestEmpAction,
} from "../../../../redux/actions/EmployeePageAction";
import { GetRemainingAdminRequestAction } from "../../../../redux/actions/AdminRequestAction";
import dayjs from "dayjs";
import axios from "axios";
import fileDownload from "js-file-download";
import { ToastContainer } from "react-toastify";
import Pagination from "../../../Utility/Pagination/Pagination";
import { useTableExcelExport } from "../../../Utility/useTableExcelExport";
import { useReactToPrint } from "react-to-print";
import FormPrintView from "../../../Utility/FormPrintView/FormPrintView";
import { buildAdminRequestPrintFields } from "../../../Utility/FormPrintView/formPrintHelpers";

const Requestmanage = ({ userData }) => {
  const [Datee, setDate] = useState("");
  const [DateFrom, setDateFrom] = useState("");
  const [DateTo, setDateTo] = useState("");
  const [TimeFrom, setTimeFrom] = useState("");
  const [TimeTo, setTimeTo] = useState("");
  const [Request, setRequest] = useState("");
  const [ApprovedById, setApprovedById] = useState(null);
  const [approvedByName, setApprovedByName] = useState("");
  // const NumberOfHours = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];
  const [NumberOfDays, setNumberOfDays] = useState("");
  const [NumberOfAvaDays, setNumberOfAvaDays] = useState("");

  const [NumberOfHours, setNumberOfHours] = useState("");
  // const NumberOfDays = [
  //   1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21,
  //   22, 23, 24, 25, 26, 27, 28, 29,
  // ];
  const [selectedFile, setSelectedFile] = useState("");
  const [NoteFile, setNoteFile] = useState("");
  const [Note, setNote] = useState("");
  const [FileeBase64, setBase64] = useState("");
  const [BorrowValue, setBorrowValue] = useState("");

  const [EmployeesId, setEmployeesId] = useState(null);
  const [isEdit, setIsEdit] = useState(false);
  const [Eye, setEye] = useState(false);
  const [AdminrequestId, setAdminrequestId] = useState(userData.id);
  const [VacationId, setVacationId] = useState(0);
  const [Search, setSearch] = useState("");
  const printRef = useRef();
  const { tableRef, onDownload } = useTableExcelExport(
    "بيانات الطلبات",
    "بيانات الطلبات",
  );
  const All = useSelector((state) => state.EmployeePageR.GetREQUESTEMP);

  const PageSize = 7;
  const dispatch = useDispatch();
  const [showManage, setshowManage] = useState(false);
  const [loading, setLoading] = useState(true);
  const [isPress, setIsPress] = useState(false);
  useEffect(() => {
    dispatch(GetAllRequestEmpAction());
  }, []);
  useEffect(() => {
    dispatch(
      GetAllRequestEmpAction(`SearchTerm=${Search}&PageSize=${PageSize}`),
    );
  }, [Search]);
  const GetRemainingAdminRequest = useSelector(
    (state) => state.AdminRequestR.GetRemainingAdminRequest,
  );

  useEffect(() => {
    if (Request !== "" && userData?.id) {
      // Dispatch to get remaining days when dependencies change
      dispatch(
        GetRemainingAdminRequestAction(
          `userId=${userData.id}&request=${Request}`,
        ),
      );

      // Then set the available days based on result
      if (GetRemainingAdminRequest !== 0 && GetRemainingAdminRequest !== -1) {
        setNumberOfAvaDays(GetRemainingAdminRequest);
      } else if (GetRemainingAdminRequest === -1) {
        setNumberOfAvaDays(0);
      }
    }
  }, [Request, userData?.id, GetRemainingAdminRequest]);

  const [showDelete, setshowDelete] = useState(false);
  const onPress = async (page) => {
    await dispatch(
      GetAllRequestEmpAction({ pageNumber: page, pageSize: PageSize }),
    );
  };
  const current = All?.currentPage;

  const handleCloseDelete = () => setshowDelete(false);
  const handleShoweDelete = (itemid) => {
    setshowDelete(true);
    setAdminrequestId(itemid);
  };

  const handleShowManage = () => setshowManage(true);

  // const handelDeleteItem = async () => {
  //   setIsPress(true);
  //   setLoading(true);
  //   await dispatch(DeleteAdminRequestAction(AdminrequestId));
  //   setLoading(false);
  //   setVacationId(null);
  //   setshowDelete(false);
  //   setIsPress(false);
  // };
  const handlePrint = useReactToPrint({
    contentRef: printRef,
    documentTitle: "بيانات الطلب",
  });

  const handlesubmit = async (e) => {
    e.preventDefault();
    if (Datee === "" || Request === "") {
      notify("من فضلك اكمل البيانات المطلوبة", "error");
      return;
    }

    if (userData.subscriptionType === "Ended-Subscription") {
      notify("تم انتهاء اشتراكك برجاء التجديد", "error");
      return;
    }
    if (
      userData.isActive === false &&
      userData.subscriptionType === "IsPaid-Subscription"
    ) {
      notify("تم انتهاء اشتراكك برجاء التجديد", "error");
      return;
    }
    if (
      userData.isActive === false &&
      userData.subscriptionType === "IsFree-Subscription"
    ) {
      notify("تم انتهاء اشتراكك برجاء التجديد", "error");
      return;
    }
    if (
      userData.isActive === false &&
      userData.subscriptionType === "IsPaid-Subscription"
    ) {
      notify("تم انتهاء اشتراكك برجاء التجديد", "error");
      return;
    }
    if (
      userData.isActive === false &&
      userData.subscriptionType === "IsFree-Subscription"
    ) {
      notify("تم انتهاء اشتراكك برجاء التجديد", "error");
      return;
    }
    if (
      userData.subscriptionType === "User-not-subscriped" &&
      All.data &&
      All.data.length > 4
    ) {
      notify("غير مسموح بأضافة اكثر من 5 من الاجازات إشترك للتفعيل ", "error");
      return;
    }
    if (
      userData.subscriptionType === "User-not-subscriped" &&
      current > 1 &&
      All.data.length > 4
    ) {
      notify("غير مسموح بأضافة اكثر من 5 من الاجازات إشترك للتفعيل ", "error");
      return;
    }
    setIsPress(true);
    setLoading(true);
    const formData = new FormData();
    formData.append("Date", Datee);
    formData.append("RequestType", Request);
    formData.append("Note", Note);
    formData.append("DateFrom", DateFrom);
    formData.append("DateTo", DateTo);
    formData.append("NumberOfDays", NumberOfDays);
    formData.append(
      "TimeFrom",
      TimeFrom !== "" ? dayjs(TimeFrom).format("hh:mm:ss") : "",
    );
    formData.append(
      "TimeTo",
      TimeTo !== "" ? dayjs(TimeTo).format("hh:mm:ss") : "",
    );
    formData.append("NumberOfHours", NumberOfHours);
    formData.append("BorrowValue", BorrowValue);
    formData.append("File", selectedFile);
    formData.append("FileDescription", NoteFile);
    await dispatch(CreateRequestEmpAction(formData));
    setDate("");
    setDateFrom("");
    setDateTo("");
    setTimeFrom("");
    setTimeTo("");
    setRequest("");
    setNumberOfDays("");
    setNumberOfHours("");
    setNote("");
    setNoteFile("");
    setSelectedFile("");
    setBase64("");
    setEmployeesId("");
    setAdminrequestId("");

    setIsEdit(false);
    setEye(false);

    setEmployeesId("");

    setIsPress(false);
    setLoading(false);
  };
  // const handleUpdate = async (e) => {
  //   e.preventDefault();
  //   if (Datee === "" || EmployeesId === null) {
  //     notify("من فضلك اكمل البيانات المطلوبة", "error");
  //     return;
  //   }

  //   if (userData.subscriptionType === "Ended-Subscription") {
  //     notify("تم انتهاء اشتراكك برجاء التجديد", "error");
  //     return;
  //   }
  //   if (
  //     userData.isActive === false &&
  //     userData.subscriptionType === "IsPaid-Subscription"
  //   ) {
  //     notify("تم انتهاء اشتراكك برجاء التجديد", "error");
  //     return;
  //   }
  //   if (
  //     userData.isActive === false &&
  //     userData.subscriptionType === "IsFree-Subscription"
  //   ) {
  //     notify("تم انتهاء اشتراكك برجاء التجديد", "error");
  //     return;
  //   }
  //   if (
  //     userData.isActive === false &&
  //     userData.subscriptionType === "IsPaid-Subscription"
  //   ) {
  //     notify("تم انتهاء اشتراكك برجاء التجديد", "error");
  //     return;
  //   }
  //   if (
  //     userData.isActive === false &&
  //     userData.subscriptionType === "IsFree-Subscription"
  //   ) {
  //     notify("تم انتهاء اشتراكك برجاء التجديد", "error");
  //     return;
  //   }
  //   if (
  //     userData.subscriptionType === "User-not-subscriped" &&
  //     All.data &&
  //     All.data.length > 4
  //   ) {
  //     notify("غير مسموح بأضافة اكثر من 5 من الاجازات إشترك للتفعيل ", "error");
  //     return;
  //   }
  //   if (
  //     userData.subscriptionType === "User-not-subscriped" &&
  //     current > 1 &&
  //     All.data.length > 14
  //   ) {
  //     notify("غير مسموح بأضافة اكثر من 5 من الاجازات إشترك للتفعيل ", "error");
  //     return;
  //   }

  //   setIsPress(true);
  //   setLoading(true);

  //   const formData = new FormData();
  //   formData.append("Id", AdminrequestId);
  //   formData.append("Date", Datee);
  //   formData.append("RequestType", Request);
  //   formData.append("Note", Note);
  //   formData.append("DateFrom", DateFrom);
  //   formData.append("DateTo", DateTo);
  //   formData.append("NumberOfDays", NumberOfDays);
  //   formData.append(
  //     "TimeFrom",
  //     TimeFrom !== "" ? dayjs(TimeFrom).format("hh:mm:ss") : ""
  //   );
  //   formData.append(
  //     "TimeTo",
  //     TimeTo !== "" ? dayjs(TimeTo).format("hh:mm:ss") : ""
  //   );
  //   formData.append("NumberOfHours", NumberOfHours);
  //   formData.append("ApprovedById", userData.id);
  //   formData.append("EmployeeId", EmployeesId.id);
  //   formData.append("NewFile", selectedFile);
  //   formData.append("FileDescription", NoteFile);

  //   await dispatch(UpdateAdminRequestAction(formData));
  //   setDate("");
  //   setDateFrom("");
  //   setDateTo("");
  //   setTimeFrom("");
  //   setTimeTo("");
  //   setRequest("");
  //   setNumberOfDays("");
  //   setNumberOfHours("");
  //   setNote("");
  //   setNoteFile("");
  //   setSelectedFile("");
  //   setBase64("");
  //   setEmployeesId("");
  //   setAdminrequestId("");
  //   setVacationId("");
  //   setIsPress(false);
  //   setIsEdit(false);
  //   setLoading(false);
  // };

  // const Update = (item) => {
  //   setEmployeesId({
  //     name: item.employeeName,
  //     id: item.employeeId,
  //   });
  //   setDate(item.date);
  //   setRequest(item.request);
  //   setNote(item.note);
  //   setDateFrom(item.dateFrom);
  //   setDateTo(item.dateTo);
  //   setTimeFrom(
  //     item.timeFrom !== null ? dayjs(`1970-01-01T${item.timeFrom}`) : ""
  //   );
  //   setTimeTo(item.timeTo != null ? dayjs(`1970-01-01T${item.timeTo}`) : "");

  //   setNumberOfDays(item.numberOfDays);
  //   setNumberOfHours(item.numberOfHours);
  //   setAdminrequestId(item.id);

  //   setIsEdit(true);
  //   setEye(false);
  // };
  const Showw = (item) => {
    setEmployeesId({
      name: item.employeeName,
      id: item.employeeId,
    });
    setDate(item.date);
    setRequest(item.request);
    setNote(item.note);
    setDateFrom(item.dateFrom);
    setBorrowValue(item.borrowValue);
    setDateTo(item.dateTo);
    setTimeFrom(dayjs(`1970-01-01T${item.timeFrom}`));
    setTimeTo(dayjs(`1970-01-01T${item.timeTo}`));
    setApprovedById(item.approvedById);
    setApprovedByName(item.approvedByName || "");
    setNumberOfDays(item.numberOfDays);
    setNumberOfHours(item.numberOfHours);
    setAdminrequestId(item.id);
    setVacationId(item.vacationId);
    setNumberOfDays(item.numberOfDays);
    setNumberOfHours(item.numberOfHours);
    setAdminrequestId(item.id);
    setNoteFile(item.fileDescription);
    setIsEdit(false);
    setEye(true);
  };

  function formatFileSize(bytes) {
    if (bytes === 0) return "0 Bytes";
    const k = 1024;
    const sizes = ["Bytes", "KB", "MB", "GB", "TB"];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + " " + sizes[i];
  }
  function importData() {
    let input = document.createElement("input");
    input.type = "file";
    input.multiple = "false";
    input.onchange = (e) => {
      setSelectedFile(e.target.files[0]);
      const reader = new FileReader();
      reader.onload = () => {
        const base64 = reader.result;
        setBase64(base64);
      };

      reader.readAsDataURL(e.target.files[0]);
    };

    input.click();
  }

  const deleteFile = () => {
    setSelectedFile("");
    setBase64("");
  };

  const [popup, setpopup] = useState(false);
  const [ContentFile, setContentFile] = useState("");
  const handleClosepopup = () => {
    setpopup(false);
    setpopup("");
    setContentFile("");
  };
  const handleShowpopup = (item) => {
    setpopup(true);
    setContentFile(item);
  };
  const handleDownload = (url, filename) => {
    axios
      .get(url, {
        responseType: "blob",
      })
      .then((res) => {
        fileDownload(res.data, filename);
        setpopup(false);
      });
  };

  const res = useSelector((state) => state.EmployeePageR.AddREQUESTEMP);

  useEffect(() => {
    if (loading === false) {
      setTimeout(() => setLoading(true), 2000);
      if (res) {
        if (res.statusCode === 200 || res.statusCode === 201) {
          if (
            res.data &&
            res.data.responseMessage ===
              "Great, Administrative Request created Successfully"
          ) {
            dispatch(GetAllRequestEmpAction(`PageSize=${PageSize}`));
            notify("تم اضافة البيانات بنجاح", "success");
          } else if (
            res.data &&
            res.data.responseMessage ===
              "can't create the admin request because you exceeded your limit of holidays"
          ) {
            dispatch(GetAllRequestEmpAction(`PageSize=${PageSize}`));
            notify("تم تخطى الحد المسموح من عدد ايام الاجازات", "warn");
          }
        } else if (res.status !== 200 || res.status !== 201) {
          if (
            res.data &&
            res.data.ResponseMessage ===
              "can't create the admin request because the remaining for the request is -1"
          ) {
            notify("هذا الموظف ليس لديةاجازات كافية", "warn");
          } else notify("حدث خطأ حاول مرة اخرى", "error");
        }
        // setLoading(true);
      }
    }
  }, [loading]);
  return (
    <>
      <div className="enterr">
        <Container>
          <div className="inputs-container">
            <div className="inp-container">
              <div className="dateee">
                {" "}
                {Datee ? new Date(Datee).toLocaleDateString("en-GB") : null}
              </div>
              <i className="ty fa-solid fa-calendar-days"></i>
              <TextField
                label={
                  <Typography sx={{ fontSize: "18px", fontFamily: "Almarai" }}>
                    التاريخ
                    <span style={{ color: "red", fontSize: "21px" }}>*</span>
                  </Typography>
                }
                variant="outlined"
                type="date"
                value={Datee}
                onChange={(e) => setDate(e.target.value)}
              />
            </div>
            <div className="inp-container">
              <TextField
                focused
                label="اسم الموظف"
                variant="outlined"
                value={userData?.name || ""}
                //   className="ww"
              />
            </div>
            <div className="inp-container">
              <FormControl fullWidth>
                <InputLabel id="demo-simple-select-label">
                  {" "}
                  <Typography sx={{ fontSize: "18px", fontFamily: "Almarai" }}>
                    طلب إداري
                    <span style={{ color: "red", fontSize: "21px" }}>*</span>
                  </Typography>
                </InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  value={Request}
                  label={
                    <Typography
                      sx={{ fontSize: "18px", fontFamily: "Almarai" }}>
                      طلب إداري
                      <span style={{ color: "red", fontSize: "21px" }}>*</span>
                    </Typography>
                  }
                  onChange={(e) => {
                    setRequest(e.target.value);
                  }}>
                  <MenuItem value={"RegularLeave"}>اجازة اعتيادية</MenuItem>
                  <MenuItem value={"EmergencyLeave"}>اجازة عارضة</MenuItem>
                  <MenuItem value={"AnnualLeave"}>اجازة سنوية</MenuItem>
                  <MenuItem value={"SickLeave"}>اجازة مرضي</MenuItem>
                  <MenuItem value={"PermissionToLeave"}> اذن انصراف</MenuItem>
                  <MenuItem value={"PermissionForDelay"}> اذن تأخير</MenuItem>
                  <MenuItem value={"OfficialTaskPermit"}> اذن مأمورية</MenuItem>
                  <MenuItem value={"ComplaintRequest"}>طلب شكوى</MenuItem>
                  <MenuItem value={"InquiryRequest"}> طلب استفسار</MenuItem>
                  <MenuItem value={"BorrowRequest"}> طلب سلفة</MenuItem>
                </Select>
              </FormControl>
            </div>
            {Request === "RegularLeave" ||
            Request === "EmergencyLeave" ||
            Request === "AnnualLeave" ||
            Request === "SickLeave" ? (
              <>
                <div className="inp-container">
                  <div className="dateee">
                    {DateFrom
                      ? new Date(DateFrom).toLocaleDateString("en-GB")
                      : null}
                  </div>
                  <i className="ty fa-solid fa-calendar-days"></i>
                  <TextField
                    label={
                      <Typography
                        sx={{ fontSize: "18px", fontFamily: "Almarai" }}>
                        التاريخ من
                        <span style={{ color: "red", fontSize: "21px" }}>
                          *
                        </span>
                      </Typography>
                    }
                    variant="outlined"
                    type="date"
                    value={DateFrom}
                    onChange={(e) => setDateFrom(e.target.value)}
                  />
                </div>
                <div className="inp-container">
                  <div className="dateee">
                    {DateTo
                      ? new Date(DateTo).toLocaleDateString("en-GB")
                      : null}
                  </div>
                  <i className="ty fa-solid fa-calendar-days"></i>
                  <TextField
                    label={
                      <Typography
                        sx={{ fontSize: "18px", fontFamily: "Almarai" }}>
                        التاريخ إلى
                        <span style={{ color: "red", fontSize: "21px" }}>
                          *
                        </span>
                      </Typography>
                    }
                    variant="outlined"
                    type="date"
                    value={DateTo}
                    onChange={(e) => {
                      const toDate = new Date(e.target.value);
                      const fromDate = new Date(DateFrom);
                      setDateTo(e.target.value);

                      const diffTime = toDate.getTime() - fromDate.getTime();

                      if (!isNaN(diffTime) && diffTime >= 0) {
                        const diffDays = Math.ceil(
                          diffTime / (1000 * 3600 * 24),
                        );
                        setNumberOfDays(diffDays + 1);
                      } else {
                        setNumberOfDays(0); // Optional: handle invalid or past date
                      }
                    }}
                  />
                </div>
              </>
            ) : Request === "PermissionToLeave" ||
              Request === "PermissionForDelay" ||
              Request === "OfficialTaskPermit" ? (
              <>
                <div className="inp-container clock">
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DemoContainer components={["TimePicker"]}>
                      <TimePicker
                        label={
                          <Typography
                            sx={{ fontSize: "18px", fontFamily: "Almarai" }}>
                            التوقيت من
                            <span style={{ color: "red", fontSize: "21px" }}>
                              *
                            </span>
                          </Typography>
                        }
                        defaultValue={""}
                        value={TimeFrom}
                        onChange={(newValue) => setTimeFrom(newValue)}
                      />
                    </DemoContainer>
                  </LocalizationProvider>
                </div>
                <div className="inp-container clock">
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DemoContainer components={["TimePicker"]}>
                      <TimePicker
                        label={
                          <Typography
                            sx={{ fontSize: "18px", fontFamily: "Almarai" }}>
                            التوقيت إلى
                            <span style={{ color: "red", fontSize: "21px" }}>
                              *
                            </span>
                          </Typography>
                        }
                        defaultValue={""}
                        value={TimeTo}
                        onChange={(newValue) => {
                          const newTimeTo = newValue;
                          setTimeTo(newTimeTo);

                          const fromDate = new Date(TimeFrom);
                          const toDate = new Date(newTimeTo);

                          if (!isNaN(fromDate) && !isNaN(toDate)) {
                            const diffMilliseconds =
                              toDate.getTime() - fromDate.getTime();

                            if (diffMilliseconds >= 0) {
                              const totalMinutes =
                                diffMilliseconds / (1000 * 60);
                              const hours = Math.floor(totalMinutes / 60);
                              const minutes = Math.round(totalMinutes % 60);

                              // Store the formatted string
                              setNumberOfHours(
                                "hours " + hours + ", minutes  " + minutes,
                              );

                              // Optionally store decimal value too
                              // setDecimalHours(totalMinutes / 60);
                            } else {
                              setNumberOfHours("0 hours, 0 minutes");
                            }
                          } else {
                            setNumberOfHours("Invalid date");
                          }
                        }}
                      />
                    </DemoContainer>
                  </LocalizationProvider>
                </div>
              </>
            ) : null}
            {Request === "RegularLeave" ||
            Request === "EmergencyLeave" ||
            Request === "AnnualLeave" ||
            Request === "SickLeave" ? (
              <>
                <div className="inp-container">
                  <TextField
                    focused
                    label={
                      <Typography
                        sx={{ fontSize: "18px", fontFamily: "Almarai" }}>
                        عدد الأيام
                        <span style={{ color: "red", fontSize: "21px" }}>
                          *
                        </span>
                      </Typography>
                    }
                    type="number"
                    value={NumberOfDays}
                    onChange={(e) => setNumberOfDays(e.target.value)}
                    variant="outlined"
                    //   className="ww"
                  />
                </div>

                <div className="inp-container">
                  <TextField
                    label="عدد الأيام المتاحة"
                    variant="outlined"
                    //   className="ww"
                    focused
                    value={NumberOfAvaDays}
                    // onChange={(e) => setNumberOfAvaDays(e.target.value)}
                    type="number"
                  />
                </div>
              </>
            ) : Request === "PermissionToLeave" ||
              Request === "PermissionForDelay" ||
              Request === "OfficialTaskPermit" ? (
              <>
                <div className="inp-container">
                  <TextField
                    label={
                      <Typography
                        sx={{ fontSize: "18px", fontFamily: "Almarai" }}>
                        عدد الساعات
                        <span style={{ color: "red", fontSize: "21px" }}>
                          *
                        </span>
                      </Typography>
                    }
                    variant="outlined"
                    type="text"
                    value={NumberOfHours}
                    onChange={(e) => setNumberOfHours(e.target.value)}
                    //   className="ww"
                  />
                </div>
                {/* <div className="inp-container">
                  <TextField
                    label="عدد الساعات المتاحة"
                    variant="outlined"
                    //   className="ww"
                  />
                </div> */}
              </>
            ) : null}
            {Request === "ComplaintRequest" || Request === "InquiryRequest" ? (
              <>
                <div className="inp-container">
                  <TextField
                    label={
                      Request === "ComplaintRequest"
                        ? "عنوان الشكوى"
                        : "عنوان الاستفسار"
                    }
                    inputProps={{ maxLength: 120 }}
                    type="text"
                    variant="outlined"
                    //   className="ww"
                    onChange={(e) => setNoteFile(e.target.value)}
                    value={NoteFile}
                  />
                  <i
                    onClick={importData}
                    className="ty fa-solid fa-paperclip"
                    style={{ color: "#1866ec" }}></i>
                </div>
                {selectedFile && (
                  <div className="fi">
                    <a
                      href={FileeBase64 ? FileeBase64 : selectedFile}
                      target="blank"
                      download={selectedFile.name}>
                      {selectedFile.name ? (
                        selectedFile.name
                      ) : (
                        <i
                          className=" fa-solid fa-paperclip"
                          style={{ color: "#1866ec" }}></i>
                      )}
                    </a>
                    <div style={{ display: "block" }}>Attach File</div>
                    <button
                      style={{ background: "transparent" }}
                      className="buttonadd d">
                      <i
                        onClick={(idx) => deleteFile(idx)}
                        className="fs fa-solid fa-trash-can icon-red"
                        style={{ color: "red" }}></i>
                    </button>
                  </div>
                )}
              </>
            ) : (
              <>
                {Request === "BorrowRequest" ? (
                  <div className="inp-container">
                    <TextField
                      label="القيمة"
                      variant="outlined"
                      type="number"
                      value={BorrowValue}
                      onChange={(e) => setBorrowValue(e.target.value)}
                      s
                      //   className="ww"
                    />
                  </div>
                ) : null}
                {/* <div className="inp-container w-290">
                  <TextField
                    label="إعتماد بواسطة "
                    variant="outlined"
                    //   className="ww"
                    value={userData.name}
                    focused
                    disabled
                  />
                  <div className="input-check">
                    <input
                      className="input-check"
                      type="checkbox"
                      // value={ShowArchiv}
                      // onChange={(e) => setShowArchiv(e.target.checked)}
                    />
                  </div>
                </div> */}
                <div className="inp-container">
                  <TextField
                    focused
                    label="حالة الأعتماد"
                    variant="outlined"
                    value={
                      ApprovedById === 0 || ApprovedById === null
                        ? "تحت المراجعة"
                        : "تمت المراجعة بنجاح"
                    }
                    //   className="ww"
                  />
                </div>
                <div className="inp-container">
                  <TextField
                    label="ملاحظات"
                    variant="outlined"
                    //   className="ww"
                    onChange={(e) => setNote(e.target.value)}
                    value={Note}
                    inputProps={{ maxLength: 120 }}
                  />
                </div>
                <div className="inp-container">
                  <TextField
                    label="أرشيف المستندات"
                    inputProps={{ maxLength: 120 }}
                    type="text"
                    variant="outlined"
                    //   className="ww"
                    onChange={(e) => setNoteFile(e.target.value)}
                    value={NoteFile}
                  />
                  <i
                    onClick={importData}
                    className="ty fa-solid fa-paperclip"
                    style={{ color: "#1866ec" }}></i>
                </div>
                <div className="inp-container">
                  {selectedFile && (
                    <div className="fi">
                      <a
                        href={FileeBase64 ? FileeBase64 : selectedFile}
                        target="blank"
                        download={selectedFile.name}>
                        {selectedFile.name ? (
                          selectedFile.name
                        ) : (
                          <i
                            className=" fa-solid fa-paperclip"
                            style={{ color: "#1866ec" }}></i>
                        )}
                      </a>
                      <div style={{ display: "block" }}>Attach File</div>
                      <button
                        style={{ background: "transparent" }}
                        className="buttonadd d">
                        <i
                          onClick={(idx) => deleteFile(idx)}
                          className="fs fa-solid fa-trash-can icon-red"
                          style={{ color: "red" }}></i>
                      </button>
                    </div>
                  )}
                </div>
              </>
            )}

            <div className="inp-container"></div>
            <div className="inp-container"></div>
          </div>
          {Eye ? (
            <button className="buttonadd" onClick={handlePrint}>
              تصدير
            </button>
          ) : (
            <>
              {isEdit ? null : (
                <>
                  {loading && isPress ? (
                    <button className="buttonadd">
                      <Spinner />
                    </button>
                  ) : (
                    <button className="buttonadd" onClick={handlesubmit}>
                      إضافة
                    </button>
                  )}
                </>
              )}
            </>
          )}{" "}
          <div className="inputs-container ddl">
            <div className="inp-container ">
              {" "}
              <TextField
                label="ابحث"
                inputProps={{ maxLength: 120 }}
                type="text"
                variant="outlined"
                onChange={(e) => setSearch(e.target.value)}
                value={Search}
                //   className="ww"
              />
              <i className="ty fa-solid fa-magnifying-glass"></i>
            </div>{" "}
            <div className="inp-container"></div>
            <div className="inp-container"></div>
          </div>
        </Container>{" "}
        <Table
          ref={tableRef}
          id="my-table"
          className="maint"
          responsive
          striped
          bordered
          hover>
          <thead>
            <tr>
              <th>
                التاريخ<i className="fa-solid fa-hashtag"></i>
              </th>
              <th>
                اسم الموظف <i className="fa-solid fa-hashtag"></i>
              </th>
              <th>
                نوع الطلب <i className="fa-regular fa-calendar-check"></i>
              </th>
              <th>
                من<i className="fa-solid fa-hashtag"></i>
              </th>
              <th>
                إلى<i className="fa-solid fa-hashtag"></i>
              </th>
              <th>
                عدد<i className="fa-solid fa-hashtag"></i>
              </th>
              <th>
                حالة الاعتماد <i className="fa-regular fa-calendar-check"></i>
              </th>
              <th>
                ملاحظات <i className="fa-regular fa-calendar-check"></i>
              </th>
              <th>
                ارشيف المستندات <i className="fa-regular fa-calendar-check"></i>
              </th>

              <th className="icon-w"> </th>
            </tr>
          </thead>
          <tbody>
            {All && All.data && All.data.length > 0
              ? All.data.map((item, idx) => {
                  // ForceCount = ALL.TotalPages - 1;
                  return (
                    <tr key={idx}>
                      <td>{new Date(item.date).toLocaleDateString("en-GB")}</td>
                      <td>{item.employeeName}</td>
                      <td>
                        {item.request === "RegularLeave"
                          ? "اجازة اعتيادية"
                          : item.request === "EmergencyLeave"
                            ? "اجازة عارضة"
                            : item.request === "AnnualLeave"
                              ? "اجازة سنوية"
                              : item.request === "SickLeave"
                                ? "اجازة مرضي"
                                : item.request === "PermissionToLeave"
                                  ? "اذن انصراف"
                                  : item.request === "PermissionForDelay"
                                    ? "اذن تأخير"
                                    : item.request === "OfficialTaskPermit"
                                      ? "اذن مأمورية"
                                      : item.request === "ComplaintRequest"
                                        ? "طلب شكوى"
                                        : item.request === "InquiryRequest"
                                          ? "طلب استفسار"
                                          : item.request === "BorrowRequest"
                                            ? "طلب سلفة"
                                            : ""}
                      </td>
                      <td>
                        {item.timeFrom !== null
                          ? item.timeFrom
                          : item.dateFrom !== null
                            ? new Date(item.dateFrom).toLocaleDateString(
                                "en-GB",
                              )
                            : ""}
                      </td>
                      <td>
                        {item.timeTo !== null
                          ? item.timeTo
                          : item.dateTo !== null
                            ? new Date(item.dateTo).toLocaleDateString("en-GB")
                            : ""}
                      </td>
                      <td>
                        {item.numberOfDays !== null
                          ? item.numberOfDays + " أيام"
                          : item.numberOfHours !== null
                            ? item.numberOfHours
                            : ""}
                      </td>
                      {item.approvedById === 0 || item.approvedById === null ? (
                        <td>تحت المراجعة</td>
                      ) : (
                        <td>تمت المراجعة بواسطة {item.approvedByName}</td>
                      )}

                      <td>{item.note}</td>
                      <td>
                        {item.fileUrl !== null ? (
                          <>
                            <button
                              style={{
                                backgroundColor: "transparent",
                                border: "none",
                              }}
                              onClick={() => handleShowpopup(item.fileUrl)}>
                              {" "}
                              <i className="fa-solid fa-paperclip"></i>
                            </button>
                            <span>{item.fileDescription}</span>
                          </>
                        ) : (
                          " "
                        )}
                      </td>
                      <td className="icon-w">
                        <i
                          onClick={() => Showw(item)}
                          className="fa-solid fa-eye"
                          style={{ color: "#333" }}></i>
                      </td>
                    </tr>
                  );
                })
              : null}
          </tbody>
        </Table>
        <ToastContainer autoClose={1200} />
        <Pagination
          onPress={onPress}
          PageSize={PageSize}
          PageCount={All ? All.totalPages : null}
          // ForceCount={ForceCount}
          // itemsPerPage={2}
          // items={FilesDetails.data}
        />
        <button className="buttonadd" onClick={onDownload}>
          تصدير
        </button>
      </div>
      <div className="popimg">
        <Modal
          show={popup}
          onHide={handleClosepopup}
          backdrop="static"
          centered
          keyboard={false}
          contentClassName="popimg"
          style={{ width: "90%", margin: "0px auto", textAlign: "center" }}>
          <Modal.Header closeButton>
            <Modal.Title>عرض المستند</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {" "}
            {ContentFile.split(".").pop().toLowerCase() === "png" ||
            ContentFile.split(".").pop().toLowerCase() === "jpg" ||
            ContentFile.split(".").pop().toLowerCase() === "jpeg" ||
            ContentFile.split(".").pop().toLowerCase() === "svg" ? (
              <img src={ContentFile} alt="" />
            ) : (
              <Button
                variant="secondary"
                className="close"
                onClick={() =>
                  handleDownload(
                    ContentFile,
                    `document.${ContentFile.split(".").pop().toLowerCase()}`,
                  )
                }>
                تحميل ملف بصيغة {ContentFile.split(".").pop().toLowerCase()}{" "}
                <i className="fa-solid fa-file-export"></i>
              </Button>
            )}
          </Modal.Body>

          <Modal.Footer>
            <Button
              variant="secondary"
              className="close"
              onClick={handleClosepopup}>
              إغلاق
            </Button>
            {ContentFile.split(".").pop().toLowerCase() === "png" ||
            ContentFile.split(".").pop().toLowerCase() === "jpg" ||
            ContentFile.split(".").pop().toLowerCase() === "jpeg" ||
            ContentFile.split(".").pop().toLowerCase() === "svg" ? (
              <Button
                variant="secondary"
                className="close"
                onClick={() =>
                  handleDownload(
                    ContentFile,
                    `document.${ContentFile.split(".").pop().toLowerCase()}`,
                  )
                }
                // onClick={() =>
                //   downloadFile({ url: ContentFile, filename: "newfile.png" })
                // }
              >
                تحميل الصورة
              </Button>
            ) : null}
            {/* <a  href={ContentFile}  className="close" >
            تحميل الملف
          </a> */}
          </Modal.Footer>
        </Modal>
      </div>
      <FormPrintView
        ref={printRef}
        title="بيانات الطلب"
        fields={buildAdminRequestPrintFields({
          EmployeesId: { name: userData?.name },
          Datee,
          Request,
          DateFrom,
          DateTo,
          TimeFrom,
          TimeTo,
          NumberOfDays,
          NumberOfHours,
          BorrowValue,
          NoteFile,
          Note,
          approvedById: ApprovedById,
          approvedByName,
        })}
      />
    </>
  );
};
export default Requestmanage;
